import {useMemo, useState} from "react";
import * as Yup from 'yup';
import InputMask from "react-input-mask";
import {Formik, Form, Field, ErrorMessage} from "formik";

import {FormDataCadastro} from "../../_pages/PageCadastro";

interface PropsFormCadastro {
    onSubmit: (body: FormDataCadastro) => void;
    initial?: FormDataCadastro;
}

export default function FormCadastro({initial = {} as FormDataCadastro, onSubmit}: PropsFormCadastro) {
    const initialValues = useMemo(() => ({
        nome: '', email: '', telefone: '', senha: '', confirmacao_senha: '', ...initial
    }), [initial]);

    const validationSchema = useMemo(() => Yup.object().shape({
        nome: Yup.string().trim().required(),
        email: Yup.string().email().required(),
        telefone: Yup.string()
            .matches(/\(\d{2}\)\s\d{5}-\d{4}/gi)
            .required(),
        senha: Yup.string()
            .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/g, 'A senha deve atender a todas as condições.')
            .ensure().required(),
        confirmacao_senha: Yup.string()
            .matches(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/g, 'A senha deve atender a todas as condições.')
            .test('comparar', 'Senhas não correspondem', function (confirmacao_senha) {
                return confirmacao_senha === this.parent.senha;
            })
            .ensure().required()
    }), []);

    function handleSubmit(values: FormDataCadastro) {
        onSubmit(values);
    }

    return <>
        <Formik initialValues={initialValues} onSubmit={handleSubmit}
                validationSchema={validationSchema}>
            {({values: {senha}}) => {
                const passCond = [
                    senha.length >= 8,
                    /[a-z]/.test(senha),
                    /[A-Z]/.test(senha),
                    /\d/.test(senha)
                ];
                return <Form className="d-flex flex-column gap-2">
                    <div className="form-outline mb-4">
                        <label htmlFor="nome">Nome completo</label>
                        <Field name="nome" type="text" className="form-control form-control-lg" id="nome" required placeholder="Nome completo"/>
                        <ErrorMessage name="nome" component="small" className="text-danger"/>
                    </div>
                    <div className="form-outline mb-4">
                        <label htmlFor="email">E-mail</label>
                        <Field name="email" type="email" className="form-control form-control-lg" id="email" required placeholder={'E-mail'}/>
                        <ErrorMessage name="email" component="small" className="text-danger"/>
                    </div>
                    <div className="form-outline mb-4">
                        <label htmlFor="telefone">Telefone</label>
                        <Field as={InputMask} id="telefone" name="telefone" className="form-control form-control-lg"
                               mask="(99) 99999-9999" required placeholder={'(99) 99999-9999'}/>
                        <ErrorMessage name="telefone" component="small" className="text-danger"/>
                    </div>
                    <div className="form-outline mb-4">
                        <PasswordField id="senha" label="Senha" describedBy="cadastro-senha-requisitos"/>
                        <ErrorMessage name="senha" component="small" className="text-danger"/>

                        <div className="auth-sesc-password-rules" id="cadastro-senha-requisitos">
                            <div className="auth-sesc-password-rules-title">
                                <span>Para criar sua senha:</span>
                                <span>{passCond.filter(Boolean).length}/4 requisitos</span>
                            </div>
                            <ul>
                                {condPassword(passCond[0], '8 caracteres ou mais')}
                                {condPassword(passCond[1], 'Uma letra minúscula')}
                                {condPassword(passCond[2], 'Uma letra maiúscula')}
                                {condPassword(passCond[3], 'Um número')}
                            </ul>
                        </div>
                    </div>
                    <div className="form-outline mb-4">
                        <PasswordField id="confirmacao_senha" label="Confirmação de senha"/>
                        <ErrorMessage name="confirmacao_senha" component="small" className="text-danger"/>
                    </div>
                    <div className="text-center text-lg-start mt-4 pt-2">
                        <button type="submit" className="btn btn-sesc-blue w-100 btn-lg">
                            <i className="fa fa-pencil"/> Cadastrar
                        </button>
                    </div>
                </Form>
            }}
        </Formik>
    </>;
}

function PasswordField({id, label, describedBy}: {id: string; label: string; describedBy?: string}) {
    const [visible, setVisible] = useState(false);

    return <>
        <label htmlFor={id}>{label}</label>
        <div className="auth-sesc-password-input">
            <Field id={id} name={id} type={visible ? 'text' : 'password'}
                   className="form-control form-control-lg" required
                   autoComplete="new-password" aria-describedby={describedBy}
                   placeholder={label === 'Senha' ? 'Crie uma senha' : 'Repita sua senha'}/>
            <button type="button" className="auth-sesc-password-toggle"
                    onClick={() => setVisible(current => !current)} aria-label={visible ? `Ocultar ${label.toLowerCase()}` : `Mostrar ${label.toLowerCase()}`}
                    aria-pressed={visible}>
                <i className={`fa fa-${visible ? 'eye-slash' : 'eye'}`} aria-hidden="true"/>
            </button>
        </div>
    </>;
}

function condPassword(valid: boolean, msg: string) {
    return <li className={valid ? 'is-valid' : ''}>
        <i className={`fa fa-${valid ? 'check-circle' : 'circle-o'}`} aria-hidden="true"/>
        <span>{msg}</span>
    </li>
}
